import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockPartnerLogoFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const partnerLogoBlockConfig = {
  name: 'inner-block-partner-logo',
  component: defineAsyncComponent(() => import('./CmsPartnerLogo.vue')),
  innerComponent: defineAsyncComponent(() => import('./PartnerLogo.vue')),
  fields: blockPartnerLogoFields,
} satisfies ModularBlockConfig;
